module.exports = __webpack_public_path__ + "img/breezehike.7c6c7eb8.png";